"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ScholarshipOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={sectionRef} className="relative w-full overflow-hidden bg-gradient-to-br from-[hsl(30,70%,95%)] via-[hsl(30,50%,90%)] to-[hsl(30,40%,85%)] py-24 px-6 md:px-12 lg:px-24">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <svg className="w-full h-full" viewBox="0 0 1200 800" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,400 Q300,300 600,400 T1200,400 L1200,800 L0,800 Z" fill="hsl(120, 80%, 50%)" opacity="0.15" />
          <path d="M0,500 Q300,450 600,500 T1200,500 L1200,800 L0,800 Z" fill="hsl(200, 60%, 55%)" opacity="0.1" />
        </svg>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {}
        <h1 className={`font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-light mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[0.625rem]"}`}>
          Empowering Futures Through Education
        </h1>

        {}
        <p className={`font-sans text-lg md:text-xl text-foreground-light/80 mb-8 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[0.625rem]"}`}>
          Jestu Education Empowerment Network (JEEN) provides comprehensive scholarship support to underprivileged students across Uganda, breaking barriers and building brighter tomorrows.
        </p>

        {}
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[0.625rem]"}`}>
          <Link to="#scholarships">
            <Button size="lg" className="bg-accent text-foreground-accent hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] focus-ring">
              Explore Scholarship Programs
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}